// Prevent liquid-hover sweep animation on initial load
document.querySelectorAll('.nav-btn,.nav-link,.buy-btn,.product-btn,.about-btn,.contact-send')
  .forEach(function(b){b.classList.add('no-hover-anim');});
setTimeout(function(){
  document.querySelectorAll('.no-hover-anim').forEach(function(b){b.classList.remove('no-hover-anim');});
}, 600);
